import { Component, OnInit, ViewChild } from '@angular/core';
// import { SwFormDesignPreviewComponent } from 'src/app/librarys/components/app-components/sw-form-design-preview/sw-form-design-preview.component';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import {  Router, ActivatedRoute } from '@angular/router';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
// import { SwFormDesignViewComponent } from 'src/app/librarys/components/app-components/sw-form-design-view/sw-form-design-view.component';
// import { SwFormDesignAddComponent } from 'src/app/librarys/components/app-components/sw-form-design-add/sw-form-design-add.component';
import { SwDynamicFormViewComponent } from 'src/app/librarys/components/app-components/sw-dynamic-form-view/sw-dynamic-form-view.component';
import { SwDynamicFormAddComponent } from 'src/app/librarys/components/app-components/sw-dynamic-form-add/sw-dynamic-form-add.component';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { Observable } from 'rxjs';
import { ProcessToDosService } from 'src/app/librarys/serves/public/process-to-dos.service';
import { BdpEnum } from 'src/app/areas/bdp/serves/bdp-enum';
import { SwPhotoAlbumService } from 'src/app/librarys/components/basic-components/sw-photo-album/sw-photo-album.service';
import { SwEditdeleteWorkflowComponent } from 'src/app/librarys/components/app-components/sw-editdelete-workflow/sw-editdelete-workflow.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { SwToolbarComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-toolbar/sw-toolbar.component';
declare var $: any;
 
@Component({
  selector: 'sw-dynamic-form-list',
  templateUrl: './sw-dynamic-form-list.component.html',
  styleUrls: ['./sw-dynamic-form-list.component.css']
})
export class SwDynamicFormListComponent implements OnInit {
 // 表单id
 formId = "";
 formInformation = {};
 queryElement = [];
 listElement = [];
 queryInformation = {};
 information = [];
 data = {};
 pageBase: any = { current: 1, size: 10 }
 SelectData: any = [];
 checkedData: any;
 @ViewChild("add") add: SwDynamicFormAddComponent;
 @ViewChild("tirm") tirm: SwMassageConfirmComponent;
 @ViewChild('view') view:SwDynamicFormViewComponent;
 @ViewChild("swtable") swtable: SwGridTableComponent;
 @ViewChild("swtoolbar") swtoolbar: SwToolbarComponent
 prefix: string = environment.seekerWebAPI;
 //新增 修改 查看 为弹框时 传的参数
 //environmentWebAPI: string = environment.odcWebAPI; //业务服务地址
 environmentWebAPI: string = ''; //业务服务地址  zll
 environmentCkeditor: string = environment.staticFileUrl;//（富文本图片保存的服务地址 暂时写死）
 //新增 修改 查看 为tab类型时 传的参数
 //WebAPIType: string = 'odc'; //（业务服务地址）用于新增 修改 查看的tab页面传参 （用于tab页面匹配environment.odcWebAPI）
 WebAPIType: string = ''; //（业务服务地址）用于新增 修改 查看的tab页面传参 （用于tab页面匹配environment.odcWebAPI） zll
 CkeditorType: string = 'staticFileUrl'; //（富文本图片保存的服务地址 暂时写死）用于新增 修改 查看的tab页面传参 （用于tab页面匹配environment.staticFileUrl）
 
 dirImg = "dir/img";//富文本图片保存的文件地址（暂时写死）
 dirFlash = "dir/flash";//富文本视频保存的文件地址（暂时写死）

 tableId;
 primaryKey; //主键字段channel_id
 SelectOpen = false; // 搜索下拉判断
 dictionaryDatas: any = [];//获取所有字典数据
 formRequestUrl: any = {}; //表单元素对应数据来源url对象
 isLogicParam: any = {}; // 伪删除元素

 openType:any = 1; //新增 修改 查看打开类型   1为tab类型 ; 2为弹框类型
 closeUrl: string = '';//新增 修改 查看 打开类型为tab时 保存或关闭页面 页面跳转的路径
 actFlagParam= {} // 流程审核状态属性为true 的表单元素对象

 title: string = ''; //获取该路由下的title 值
 keyWord: string = '' //流程关键字
 flowItem: any = {} //根据formId,从发起流程数据匹配出发起流程中一条json对象， 获取submitUrl 、flowName 
 variables: any = {}; //表单元素为 流程参数的值 

 keyWordEditDelete: string = '';//判断为修改流程还是删除流程（'_EDIT'或者'_DELETE'）
 isUseOrg:boolean = false; //判断表单属性是否有 isOrg=true的情况,如果有则isUseOrg=true,反之isUseOrg=false（execute的接口用到;新增、修改、删除和查询表单时用到）
 isLoading: boolean = false;
 constructor(
    private http: SwHttpClientService,
    private message: SwMassageBoxService,
    private route: ActivatedRoute,
    private jwt: SwJwtService,
    private create:SwCreateModalComponentService,
    private router: Router,
    private processToDos: ProcessToDosService, // 代办流程
    public sw: SwPhotoAlbumService,
    private systemId:SystemIdService,
    private service: BdpService,
  ) {
    this.route.queryParams.subscribe((param) => {
      this.title = param['Title']
    })
  }
  ngOnInit() {
    let uri = this.getUrl(); // 获取到当前页面url
    this.WebAPIType = uri.split('/')[1]
    this.environmentWebAPI = environment[this.WebAPIType+'WebAPI']
    let entity = { uri: uri, type: 1 }
    let url = this.prefix + "function/queryPageList";
    this.closeUrl = uri;
    //获取富文本上传图片，上传flash的文件夹
    let uploadName = uri.split('/')[2]
    this.dirImg = uploadName+'/img';
    this.dirFlash = uploadName+'/flash';
    // 获取formId
    this.http.Post(url, entity).subscribe(res => {
      this.formId = (<any>res).data.records[0].formId; // 获取到formId
      this.formInformation = { formId: this.formId };

      // 查询表单参数
      this.queryParamsPageList(this.formId).subscribe(response => {
        let params = [];
        params = (<any>response).data.records;
        this.formInformation['params'] = params;
        if (params.length) {
          let keyparam = params.filter(item => item.type == 'key');
          keyparam.forEach(val=>{
             //获取主数据表 对应的绑定主键列表
             if(val.controlType == 'text'){
               this.tableId = val['tableId']
               this.primaryKey = val['paramCode']
             }
          }) 
        }
        this.getTableFk(this.tableId)
        //数据来源url和paramCode组成的对象
        this.formInformation['params'].forEach(val=> {
          //数据来源url和paramCode组成的对象
          this.formRequestUrl[val.paramCode] = val.requestUrl
          //获取伪删除元素
          if(val.type == 'isLogic' && val.tableId == this.tableId){
            this.isLogicParam = val;
          }
          //判断表单元素是否为工作流表单   获取流程审核状态属性 isActFlag = true
          if(val.isActFlag == true) {
             this.actFlagParam = val;
             this.locationKeyWords()
          }
        })
         //获取字典数据
        //从浏览器缓存获取字典数据
        let dic = JSON.parse(this.jwt.getToken('dictionary'))
        if(dic){
          this.dictionaryDatas = [...dic]
         }
        //初始化下拉框、单选框、多选框的数据类型
        this.initRequestUrl();
        //初始化查询元素
        this.initQueryElement();
        //初始化查询元素的数据收集对象
        this.initQueryInformation();
        //初始化列表元素
        this.initListElement();
        setTimeout(()=>{
            // 查询业务数据列表
            this.getPageList();
        },200)
      })
    })

  }

    //根据主表的tabeId, 获取该主数据表所有的外键  paramCode 和 coulmId  再根据coulmId 获取对应现有表单元素elements的paramCode
    getTableFk(keyTableId){
      let param = { ids:[ keyTableId],systemId:this.systemId.getSystemId()};
     
      //根据主表tableId查询对应的 主键字段列表
      this.service.getFormDesignService().queryColumnsByTableId(param).subscribe(res => {
        if(res['code']==200){
          let columns = res['data'];
           //判断主表是否为组织权限
           if(columns.length > 0){
            //判断该表单的是否包含属性 isOrg = true的元素，若有 this.isUseOrg = true 否则 this.isUseOrg=false
            let orgs = columns.filter(item=>item.isOrg == true)
            if(orgs.length == 0){
              this.isUseOrg= false
            }else {
              this.isUseOrg = true
            }
          }
        }
      });
    }

  //加载数据,根据formId获取keyWord
   locationKeyWords() {
    let param = { entity: {}, param: { pageNum: 1, pageSize: 0 } }
    this.getInitiationProcessList(param).subscribe(data => {
      if (data["code"] == 200) {
        //获取到所有的类型
        data["data"].forEach(el => {
          if(el.formId == this.formId) {
            this.keyWord = el.keyWord;
            this.flowItem = el;
          }
        });
      }
    })
  }

  getInitiationProcessList(param:any) {
    const url = environment.activitiWebAPI + "swActivitiModel/queryListByType"; 
    return this.http.Post(url, param);
  }

  /**
 * 查询列表
 * @param {any} formId 
 * @param {any} pager 
 * @param {any} param //查询条件
 * @memberof TestListComponent
 */
  getPageList() {
    this.isLoading = true;
    this.swtoolbar.toolbarAllEnable();
    const url = this.environmentWebAPI +'dynamic/execute?action=1&formId=' + this.formId + `&isUseAlias=true&pageNum=${this.pageBase.current}&pageSize=${this.pageBase.size}&isUseOrg=${this.isUseOrg}`;
    // 过滤已删除的数据
    let param = {}
    //若为流程审核表单  找出流程审核表单元素  0:未提交, 1:审核中, 2:已通过, 3:已驳回, 4:退回重审
    if(this.actFlagParam['isActFlag'] == true) {
      param[this.actFlagParam['tableId'] + '.' + this.actFlagParam['paramCode']] = ['like', 2 , '']
    }
    let queryParams = this.queryElement;
    if (queryParams.length > 0) {
      queryParams.map(item => {
        let value = this.queryInformation[item.paramCode];
        if (value != null && value != '') {
          if(item.controlType=='datePicker') {
            let time = this.queryInformation[item.paramCode];
            let beginTime = time.split("#")[0] + " 00:00:00";
            let endTime = time.split("#")[1] + " 23:59:59";
            param[item.tableId + '.' + item.paramCode] = ['between', beginTime + "#" + endTime, ''];
          }else {
            param[item.tableId + '.' + item.paramCode] = ['like', this.queryInformation[item.paramCode], '']
          }
        }
      })
    }
    //param[this.tableId + '.' + this.isLogicParam.paramCode] = ['like', 1, '']
    // 查询业务数据
    this.http.Post(url, param).subscribe(res => {
      this.isLoading = false;
      this.information = (<any>res).data.data.list;
      let page = (<any>res).data.data;
      this.pageBase['current'] = page.pageNum;
      this.pageBase['pages'] = Math.ceil(page.total * 1.0 / page.pageSize);
      this.pageBase['size'] = page.pageSize;
      this.pageBase['total'] = page.total;
    })
  }
  //字典中value对应的text值
  initDictionaryText(paramCode,datas) {
    //如果数据来源url不为空
    if(this.formRequestUrl[paramCode]){
      let requestUrl = this.formRequestUrl[paramCode]
      let param1 = requestUrl.split("/")[1];
      //决定那条数据
      let param2 = requestUrl.split("/")[2];
      //判断元素类型
      let type = this.formInformation['params'].filter(item=> item.paramCode == paramCode)[0]['controlType']
      //对数据来源的数据进行过滤
      //param为1 数据来源为字典
      if(param1 == 1) {
        let data = datas +"";//设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
        //获取页面字典值 
        let dataArray = []
        if(data) {
          dataArray = data.split(",");
        }
         //获取页面字典 text值
         let dataString = '';
         let requestUrlData = this.dictionaryDatas.filter(val=> {
          return val.parentId == param2;
         })
         requestUrlData.forEach(val=>{
             dataArray.forEach(ele=> {
                //判断是否为is_xx true 或者false
                if (ele == 'true') {
                  ele = '1'
                } else if (ele == 'false') {
                  ele = '0'
                }
               if(val.dictionaryValue == ele){
                 dataString=dataString + "<span class=\"state-success\">"+val.dictionaryName+"</span> "
               }
             })
         })
         return dataString
      }else if(param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')){
        //当为关联表单中的字典值时
        let data = datas +"";//设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
        //获取页面字典值 
        let dataArray = []
        if(data) {
          dataArray = data.split(",");
        }
        let dataString = '';
        dataArray.forEach(ele=> {
          //判断是否为is_xx true 或者false
          if (ele == 'true') {
            ele = '1'
          } else if (ele == 'false') {
            ele = '0'
          }
          let dictionaryName = this.dictionaryDatas.filter(item=>item.dictionaryValue == ele)[0]['dictionaryName']
          dataString=dataString + "<span class=\"state-success\">"+dictionaryName+"</span> "
       })
       
        return dataString
      }else if(param1 == 3 && (param2 == 1 || param2 == 2)){
         let dataString = this.fecthLinkOrgOrUser(paramCode,datas)
        return dataString
      }else {
        return datas
      }
    }else if(this.actFlagParam['paramCode'] == paramCode){
      //返回原来值
      return  this.auditState(datas)
    }else {
      return datas
    }

  }

  //页面匹配审核状态
  auditState(state) {
    let  dataString = '';
    switch (state){
      case 0:  dataString = '<span  class="state-error">未提交</span>'; break;
      case 1:  dataString = '<span  class="state-info">审核中</span>'; break;
      case 2:  dataString = '<span  class="state-success">已通过</span>'; break;
      case 3:  dataString = '<span  class="state-waring">已退回</span>'; break;
      case 4:  dataString = '<span  class="state-error">已拒绝</span>';  break; 
      case 5:  dataString = '<span  class="state-error">已撤销</span>';  break; 
  }
    return dataString
  }

  //页面匹配关联组织或系统用户数据
  fecthLinkOrgOrUser(paramCode,datas){
    //关联系统用户数据匹配
    let data = datas +"";//设置为字符串 便于后面分割为数组
    //获取展示系统用户id数组
    let dataArray = []
    if(data) {
      dataArray = data.split(",");
    }
    let dataStrings = '';
    let requestStrData = []
    let requestData = this.formInformation['params'].filter(item=>item['paramCode'] == paramCode)[0]['requestData'] //所有元素查找对应的元素 获取其requestData数组值
    dataArray.forEach(ele=> {
      let name = requestData.filter(item=>item.id == ele)[0]['text']
      if(name){
        requestStrData.push(name)
      }
    })
    dataStrings = requestStrData.join(" ")
    return dataStrings
  }

  //类型为文本框 且为查看列表详情标签时 判断是否为关联组织或关联用户
  isLinkOrgOrUser(requestUrl) {
    let arr = requestUrl.split("/");
    //判断arr[1]为3 代表为关联系统用户或组织; 
    if( arr[1]=='3'){
      return true
    }else {
      return false
    }
  }
  //类型为文本框 且为查看列表详情标签时 获取对应列表数据（匹配为关联组织或关联系统用户数据）
  fetchOrgOrUser(paramCode,datas){
    let dataString = this.fecthLinkOrgOrUser(paramCode,datas)
    return dataString
  }
   //点击单选框触发事件
   radioOnChange(e,val,element) {
    if(e.target.checked){
      this.queryInformation[element.paramCode] = val.id+'';
    }
  }
  //判断单选框是否为 是和否两项   为两项返回true用radio  大于两项用下拉框展示
  judgeRadio(data) {
    if(data.requestData){
    if(data.requestData.length != 2) {
      return false
    }else {
      let num = 0;
      data.requestData.forEach(val=>{
        if(val.text == '是'){
          num = 1;
        }
      })
      if(num ==1){
        return true
      }else {
        return false
      }
    }
    }
  }
  clickSelect(){
    this.pageBase.current = 1;
    this.getPageList();
  }
  reset() {
    $(".icheck-turquoise input[type='radio']").prop("checked",false)
    this.queryInformation = {};
    this.getPageList();
  }

  //按钮点击事件
  onOperation(event) {
    switch (event) {
      case "add": this.clickAdd(); break;//新增
      case "modify": this.clickUpdate(); break;//修改
      case "view": this.clickRead(); break;//查看
      case "delete": this.clickDelete(); break;//删除
      case "flow_add": this.clickFlowAdd(); break;//流程新增
      case "flow_modify": this.clickFlowModify(); break;//流程修改
      case "flow_delete": this.clickFlowDelete(); break;//流程删除
    }
  }
  //按钮打开方式
  onOpenType($event) {
    //弹出层打开
    if($event == 'SYS0601') {
      this.openType = 2
    }else if($event == 'SYS0602') {
      //tab页打开
      this.openType = 1
    }else {
      //默认 tab页打开
      this.openType = 1
    }
  }

  //流程新增 
  clickFlowAdd() { 
    let param = {
      Title:this.flowItem.flowName,
      Operate: BdpEnum.SYS_PROCESS_ADD,
      process:1,
      formId: this.flowItem.formId || undefined,
      keyWord: this.flowItem.keyWord,
      version: this.flowItem.version,
      firstSid: this.flowItem.firstSid
    }
    this.router.navigateByUrl('').then(()=>{
      let formid = this.flowItem.formId || this.formId
      this.router.navigate(['/oa/DynamicFormRender/'+formid], {
        queryParams: param ,
      });
    })
  }
  //流程修改
  clickFlowModify() { 
    if (this.SelectData.length == 1) {
      let keyWordEdit = this.keyWord+'_EDIT';
      this.keyWordEditDelete = '_EDIT'
      //方法1: 动态创建确认框(推荐)
      this.create.createModal(SwEditdeleteWorkflowComponent,{type:"edit",keyWord: keyWordEdit},this.flowProcess.bind(this))
    } else {
      this.message.danger('请选择一行数据')
    }
  }
  
  //流程删除 
  clickFlowDelete() {
    // 删除
    if (this.SelectData.length == 1) {
      let keyWordDelete = this.keyWord+'_DELETE';
      this.keyWordEditDelete = '_DELETE'
      //方法1: 动态创建确认框(推荐)
      this.create.createModal(SwEditdeleteWorkflowComponent,{type:"delete",keyWord: keyWordDelete},this.flowProcess.bind(this))

    } else {
      this.message.danger('请选择一行数据')
    }
  }
  //流程删除、流程修改服务
  flowProcess(reason) {
    this.initVariables()
    let param = {
      key: this.keyWord+this.keyWordEditDelete,
      businessKey: this.keyWord+this.keyWordEditDelete + ":" + this.checkedData[this.primaryKey],
      variables: this.variables
    }
    if(reason){
      param['comment'] = reason['reason']
    }
    // 开启审批流程
    this.processToDos.startActiviti(param).subscribe(
      result => {
        if (result.code == 200) {
          if(this.keyWordEditDelete == '_DELETE') {
            this.message.success("删除流程提交成功");
          }else{
            this.message.success("修改流程提交成功");
          }
          this.getPageList();
          // 刷新工作台数据
          this.processToDos.oninitProcessToDos();
        } else {
          this.message.danger(result.msg);
        }
      }
    )
  } 

  initVariables() {
    //目前不包括上传图片 上传附件流程参数
    this.formInformation['params'].forEach(value=>{
      if(value.isActParam){
        this.variables[value.actCode] = this.checkedData[value.paramCode]
        //判断流程参数是否来自字典或关联表单
        if(value.requestUrl){
          //决定数据来源
          let param1 = value.requestUrl.split("/")[1];
          let type = value['controlType']; //获取元素类型
          //param1：1 数据来源为数据字典， param1：2 数据来源为钉钉用户 
          //param1：0 数据来源为绑定的表单
          if(param1 == 1 || param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')) {
            let checkedDataValue = this.checkedData[value.paramCode]+''; //设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
            if(checkedDataValue){
                let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                arr11.forEach(ele => {
                  //判断是否为is_xx true 或者false
                  if(ele =='true'){
                    ele = '1'
                    //流程参数
                    this.variables[value.actCode] = ele;
                  }else if(ele == 'false'){
                    ele = '0'
                    this.variables[value.actCode] = ele;
                  }
                });
             }
          }
        }
      }

    })
  }

 //点击查看大图
  openphoto(e,businessId,businessCode) {
    let param = {objectId:businessId,code:businessCode}
    this.http.Post(environment.fileWebAPI+"refFileObject/queryList",param).subscribe(data=>{
      if(data && data["code"] == 200){
        let path = []
        let dataList = data["data"]["records"]
        if(dataList.length > 0) {
          dataList.forEach(val=>{
            path.push(environment.staticFileUrl+val.filePath+val.fileName)
          })
          let photosData = { path: path, index: 0 };
          this.sw.showPhotoAlbum(photosData);
        }
        e.stopPropagation();
      }
    })

  }

  //初始化图片
  initImgPath(data) {
    let src = '';
    if(data){
        src = environment.staticFileUrl+data;
      } else{
        src = '/assets/Images/nophoto.jpg'
    } 
    return src
  }

  //初始化toolBar数据
  toolbarData($event) {
    let toolbarData = $event
    //获取查看的toolbar数据
    let data = toolbarData.filter(val=>val['functionCode'] == 'view')
    if(data && data.length){
      //判断openType的值
      this.onOpenType(data[0]['target'])
    }
  }

  //点击字段查看详情
  goToView($event,data) {
    $event.stopPropagation();
    this.viewRead(data)
  }

  //查看
  clickRead() {
    if (this.SelectData.length == 1) {
     this.viewRead(this.checkedData)
    } else {
      this.message.danger("请选择一条数据");
    }
  }

 //查看功能
  viewRead(checkedData) {
    if(this.openType == 2){
      //弹框类型
      let param = {'formInformation':this.formInformation, 'checkedData': checkedData, 'title': this.title}
      this.create.createModal(SwDynamicFormViewComponent,param)
    }else if(this.openType == 1) {
      //tab类型
      let param = {
       'formId': this.formId,  //表单id  用于查询新增的表单元素
       'checkedId': checkedData[this.primaryKey],  //选中的行数据 id  ,及主键元素的值  （修改页面可根据主键tableId,paramCode和该值获取该行数据）
       'environment': this.WebAPIType, //1.CkeditorType：富文本图片保存服务地址; 2.CkeditorType：富文本图片保存服务地址;
       'closeUrl': this.closeUrl //页面关闭后跳转的页面
     }
     let projectName= this.closeUrl.split('/')[2]
     this.router.navigateByUrl('').then(()=>{
       this.router.navigate(['/'+this.WebAPIType+'/DynamicFormView/'+projectName], {
         queryParams: { Title: '查看'+this.title, data: JSON.stringify(param)}
       });
     }) 

    }
  }

  // 新增 
  clickAdd() {
    if(this.openType == 2){
      //弹框类型
      let config = {'dirImg': this.dirImg,'dirFlash': this.dirFlash,'environmentWebAPI': this.environmentWebAPI}
      let param = {'formInformation': this.formInformation, 'checkedData': null, 'config': config, 'title': this.title}
      this.create.createModal(SwDynamicFormAddComponent,param,this.getList.bind(this))
    }else if(this.openType == 1){
      //tab类型
      let param = {
        'formId': this.formId,  //表单id  用于查询新增的表单元素
        'checkedId': null,  //选中的行数据 id  ,及主键元素的值  （新增页面可根据主键tableId,paramCode和该值获取该行数据）
        'environment': this.WebAPIType, //1.CkeditorType：富文本图片保存服务地址; 2.CkeditorType：富文本图片保存服务地址;
        'closeUrl': this.closeUrl //页面关闭后跳转的页面
      }
      let projectName= this.closeUrl.split('/')[2]
      this.router.navigateByUrl('').then(()=>{
        this.router.navigate(['/'+this.WebAPIType+'/DynamicFormAdd/'+projectName], {
          queryParams: { Title: '新增'+this.title, data: JSON.stringify(param)}
        });
      })
    }
    
  }

  // 修改
  clickUpdate() {
    if (this.SelectData.length == 1) {
      if(this.openType == 2) {
        //弹框类型
        let config = {'dirImg': this.dirImg,'dirFlash': this.dirFlash,'environmentWebAPI': this.environmentWebAPI}
        let param = {'formInformation': this.formInformation, 'checkedData': this.checkedData, 'config': config, 'title': this.title}
        this.create.createModal(SwDynamicFormAddComponent,param,this.getList.bind(this))
      }else if(this.openType == 1) { 
        //tab类型
        let param = {
          'formId': this.formId,  //表单id  用于查询新增的表单元素
          'checkedId': this.checkedData[this.primaryKey],  //选中的行数据 id  ,及主键元素的值  （修改页面可根据主键tableId,paramCode和该值获取该行数据）
          'environment': this.WebAPIType, //1.CkeditorType：富文本图片保存服务地址; 2.CkeditorType：富文本图片保存服务地址;
          'closeUrl': this.closeUrl //页面关闭后跳转的页面
        }
        let projectName= this.closeUrl.split('/')[2]
        this.router.navigateByUrl('').then(()=>{
          this.router.navigate(['/'+this.WebAPIType+'/DynamicFormEdit/'+projectName], {
            queryParams: { Title: '修改'+this.title, data: JSON.stringify(param)}
          });
        })
      }
    } else {
      this.message.danger("请选择一条数据");
    }
  }

  //删除
  clickDelete() {
    if (this.SelectData.length > 0) {
      this.tirm.openCLick("确认删除数据？", (data) => {
        if (data) {
          this.deleteOK();
        }
      })
    } else {
      this.message.danger("至少选择一条数据");
    }
  }

  // 确认删除
  deleteOK() {
    let ids = '';
    this.SelectData.forEach(item => {
      ids += "'" + item[this.primaryKey] + "',"
    })
    ids = ids.substring(0, ids.length - 1);
    let obj = {}
    obj[this.tableId + '.' + this.primaryKey] = ['in', ids, '']
    obj[this.tableId + '.' + this.isLogicParam.paramCode] = ['', '', 1]
    this.execute(obj, 3, this.formId).subscribe(
      _ => {
        this.message.success("删除成功");
        this.SelectData = [];
        this.checkedData = null;
        this.getPageList();
      })
  }


  //操作业务数据业务数据
  execute(param, action: number, formId): Observable<any> {
    let url = this.environmentWebAPI + `dynamic/execute?action=${action}&formId=${formId}&isUseOrg=${this.isUseOrg}`;
    return this.http.Post(url, {
      ...param,
    })
  }



  // 子页面发射,刷新列表
  getList() {
    this.message.success("操作成功");
    this.getPageList();
  }


  //分页
  ClickPageQuery(event) {
    this.pageBase = event;
    this.getPageList();
  }


  //初始化查询元素
  initQueryElement() {
    let params = this.formInformation['params'];
    params.forEach((val) => {
      if (val.isQueryParam == 1) {
        this.queryElement.push(val);
      }
    })
  }
  
  //初始化单选框、下拉框、多选框的数据
  initRequestUrl() {
    //用于存储接受的数据
    //发送请求的参数
    let Params = { "param": { pageSize: 0 } };
    let that = this;
    this.formInformation['params'].forEach((value) => {
      let arr = [];
      if (value.requestUrl) {
        //决定数据来源
        let param1 = value.requestUrl.split("/")[1];
        //决定那条数据
        let param2 = value.requestUrl.split("/")[2];
        let type = value['controlType']; //获取元素类型
        value.requestData = "";
        //param1为1时  数据来源为字典
        if(param1 == 1){
            //对数据来源的数据进行过滤
            let requestUrl = this.dictionaryDatas.filter(val => {
              return val.parentId == param2;
            });
            requestUrl = requestUrl.map((val, index) => {
              return {
                // id: val.id + "",
                id:val.dictionaryValue,
                text: val.dictionaryName,
                status: false
              }
            });
            //确定需要的数据
            value.requestData = requestUrl;
        }else if(param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')){
          //关联表单
          //数据来源为绑定的表单
          let formId = param2
          //根据formId获取关联的表单元素
          this.queryParamsPageList(formId).subscribe(response => {
            let pairParam2='';//关联表单对应的表单字段元素 对应的字典 id
            let params = [];
            params = (<any>response).data.records;
            pairParam2 = params.filter(item=>item['paramCode'] == value['paramCode'])[0]['requestUrl'].split("/")[2];
            //对数据来源的数据进行过滤
            let requestUrl = this.dictionaryDatas.filter(val => {
              return val.parentId == pairParam2;
            });
            requestUrl = requestUrl.map((val, index) => {
              //将id修改为val.id
              return {
                id: val.dictionaryValue,
                text: val.dictionaryName,
                status: false
              }
            });
            //确定需要的数据
            value.requestData = requestUrl;
          })
        }else if(param1 == 3 && param2 == 1){
          //关联组织数据处理
          //查询组织结构
          let requestUrl;
          let param = { "param": { pageSize: 0 ,isAdminQuery:true}, "entity": {systemId:this.systemId.getSystemId()} }
          this.service.getDepartmentService().queryOrganizePageList(param).subscribe(
            data => {
              if (data["code"] == 200) {
                let orgarray = [];
                data["data"]["records"].forEach(e => {
                  if(e.status){
                    e.checked = false;
                    orgarray.push(e);  //筛选掉已禁用数据
                  }
                });
                requestUrl = orgarray;
                //确定需要的数据
               value.requestData = requestUrl;
              
              }
            }
          )

        }else if(param1 == 3 && param2 == 2){
         //关联系统用户
         let requestUrl;
         //查询系统所有用户
         let param1 = {systemId: this.systemId.getSystemId()}
         this.service.getUserService().queryList(param1).subscribe( //查询用户
           data => {
             if (data["code"] == 200) {
               let arr1 = []
               let result = data["data"]
               result.forEach(user => {
                 if(user.status){
                   // 查询所有用户，默认没有用户被选中
                   arr1.push({id:user.userId,text:user.displayName,pid:'999',checked:false})
                 }
               });
               //所有的用户
               requestUrl = arr1
               //确定需要的数据
               value.requestData = requestUrl;
             }
           }
         )
        }

      }
    })
  }
  //初始化查询数据收集
  initQueryInformation() {
    let params = this.formInformation['params'];
    params.forEach((val) => {
      if (val.isQueryParam == 1) {
        this.queryInformation[val.paramCode] = ""
      }
    }, this)
  }
  //初始化列表元素
  initListElement() {
    let params = this.formInformation['params'];
    params.forEach(val => {
      if (val.isListParam == 1) {
        this.listElement.push(val);
      }
    })
  }

  initData(val) {
    if (val.requestUrl) {
      let value = {};
      val.requestData.forEach(v => {
        value[v.id] = v.text;
      })
      this.data[val.paramCode] = value;
    }
  }



    // 选择数据
   OutSelectData(event) {
     this.swtoolbar.toolbarAllEnable();
     if (event.length > 0) {
       this.checkedData = event[eval.length - 1];
       this.SelectData = event;
       if(event.length > 1) {
         this.swtoolbar.toolbarDisable("modify");
         this.swtoolbar.toolbarDisable("view");
         this.swtoolbar.toolbarDisable("flow_modify");
         this.swtoolbar.toolbarDisable("flow_delete");
       }
     } else {
       this.SelectData = [];
       this.checkedData = null;
     }
   }


  /**
   * 获取当前页面的url 
   * 
   * @returns 
   * @memberof TestListComponent
   */
  getUrl() {
    // 
    let url: string = "";
    this.route.pathFromRoot.map(item => {
      if (item.snapshot.url.length) {
        url += "/" + item.snapshot.url[0].path
      }
    })
    return url;
  }


  /**
 * 根据formId查询参数
 * @param param
 * @returns {Observable<any>}
 */
  queryParamsPageList(formId) {
    let param = {
      entity: { formId: formId },
      param: { pageSize: 0, orderBy: "seq" }
    }
    const url = this.prefix + 'form/queryParamsPageList';
    return this.http.Post(url, { ...param });
  }
}
